// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3dyLh","row":"ProcedureTreatmentSummary_row__eCWxc"};